import { createAction, props } from "@ngrx/store";
import { Survey, SurveyQuestion, SurveyResponse } from "@app/schemas/surveys";

export const setSurvey = createAction(
  'Survey Retrieved',
  props<{ survey: Survey }>(),
);

export const updateSurveyOptions = createAction(
  'Survey Question Updated',
  props<{ question_id: number, question: SurveyQuestion }>(),
)

export const updateSurveyResponse = createAction(
  'Survey Response Updated',
  props<{ response: SurveyResponse[] }>(),
)

export const loadSurveyQuestionsFromStorage = createAction(
  'Survey Questions Loaded From Storage',
  props<{ questions: SurveyQuestion[] }>(),
)

export const setRiasecScore = createAction(
  'Riasec Score Set',
  props<{ riasecScore: any }>(),
)